import React from 'react';

export enum APriceSize {
  Large = 'Large',
  Small = 'Small',
}

export interface APriceProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: APriceSize;
  value: string;
}
